import React from 'react';
import './parasec4.css'

const Parasec4 = (props) => {
    return ( 
        <p className={props.stylee}>{props.title}</p>
     );
}
 
export default Parasec4;